module.exports = __webpack_public_path__ + "img/montserrat-v15-latin-600.3deb98ef.svg";